<template>
  <div id="contenedor-default-adjudicacion" class="bkground">
    <template v-if="cargandoAdjudicacion">
      <v-row>
        <v-col cols="12" md="4">
          <v-skeleton-loader type="card"></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="8">
          <v-skeleton-loader type="card"></v-skeleton-loader>
        </v-col>
      </v-row>
    </template>

    <template v-else>
      <v-row>
        <v-col cols="12" md="4">
          <v-card class="rounded-lg mb-4">
            <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
              <v-icon left small color="white">mdi-file-document-outline</v-icon>
              Informacion General
            </v-card-title>
            <v-card-text class="pt-4">
              <v-list dense class="transparent">
                <v-list-item class="px-0">
                  <v-list-item-icon class="mr-3">
                    <v-icon small color="grey">mdi-file-sign</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption">
                      Numero de Contrato
                    </v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ getAdjudicacion.numeroContrato || 'Sin numero' }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="px-0">
                  <v-list-item-icon class="mr-3">
                    <v-icon small color="grey">mdi-file-certificate</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption">
                      Numero de Dictamen
                    </v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ getAdjudicacion.numeroDictamen || 'Sin dictamen' }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="px-0">
                  <v-list-item-icon class="mr-3">
                    <v-icon small color="grey">mdi-calendar</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption">
                      Fecha de Adjudicacion
                    </v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ formatoFechaHumano(getAdjudicacion.fecha) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="px-0">
                  <v-list-item-icon class="mr-3">
                    <v-icon small color="grey">mdi-account-tie</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption">
                      Contratista
                    </v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ getContratista.nombreRazonSocial || 'Sin contratista' }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-divider class="my-3"></v-divider>

              <div>
                <span class="text-caption grey--text">Objeto de la Adjudicacion</span>
                <p class="text-body-2 mt-1 mb-0">{{ getAdjudicacion.meta || 'Sin descripcion' }}</p>
              </div>
            </v-card-text>
          </v-card>

          <v-card class="rounded-lg mb-4">
            <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
              <v-icon left small color="white">mdi-domain</v-icon>
              Contratista
            </v-card-title>
            <v-card-text class="pt-4">
              <v-list dense class="transparent">
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption">RFC</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ getContratista.rfc || 'Sin RFC' }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption">Representante</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ getContratista.nombreRepresentante || 'Sin representante' }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption">
                      Correo Electronico
                    </v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium text-break">
                      {{ getContratista.correoElectronico || 'Sin correo' }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption">Ubicacion</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ getUbicacionContratista }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>

        </v-col>

        <v-col cols="12" md="8">
          <v-card class="rounded-lg mb-4">
            <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
              <v-icon left small color="white">mdi-cash-multiple</v-icon>
              Montos
            </v-card-title>
            <v-card-text class="pt-4">
              <v-row class="text-center">
                <v-col cols="12" md="4">
                  <div class="pa-3 rounded-lg" style="background: rgba(0,0,0,0.02);">
                    <div class="text-caption grey--text mb-1">Importe</div>
                    <div class="text-h6 font-weight-bold primary--text">
                      {{ getAdjudicacion.importe | currency }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="pa-3 rounded-lg" style="background: rgba(0,0,0,0.02);">
                    <div class="text-caption grey--text mb-1">IVA</div>
                    <div class="text-h6 font-weight-bold">
                      {{ getAdjudicacion.iva | currency }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="pa-3 rounded-lg success lighten-5">
                    <div class="text-caption grey--text mb-1">Total</div>
                    <div class="text-h6 font-weight-bold success--text">
                      {{ getAdjudicacion.total | currency }}
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-divider class="my-4"></v-divider>
              <v-row>
                <v-col cols="12" md="6">
                  <div class="text-caption grey--text">Porcentaje IVA</div>
                  <div class="font-weight-medium">{{ getAdjudicacion.porcentajeIva || 0 }}%</div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="text-caption grey--text">Anticipo</div>
                  <div class="font-weight-medium">
                    {{ getAdjudicacion.porcentajeAnticipo || 0 }}%
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="rounded-lg mb-4">
            <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
              <v-icon left small color="white">mdi-calendar-range</v-icon>
              Fechas y Plazos
            </v-card-title>
            <v-card-text class="pt-4">
              <v-row>
                <v-col cols="12" md="8">
                  <v-timeline dense align-top>
                    <v-timeline-item small color="info" icon="mdi-calendar-check">
                      <div>
                        <span class="text-caption grey--text">Fecha de Adjudicacion</span>
                        <div class="font-weight-medium">
                          {{ formatoFechaHumano(getAdjudicacion.fecha) }}
                        </div>
                      </div>
                    </v-timeline-item>
                    <v-timeline-item small color="success" icon="mdi-play">
                      <div>
                        <span class="text-caption grey--text">Fecha de Inicio</span>
                        <div class="font-weight-medium">
                          {{ formatoFechaHumano(getAdjudicacion.fechaInicio) }}
                        </div>
                      </div>
                    </v-timeline-item>
                    <v-timeline-item small color="warning" icon="mdi-flag-checkered">
                      <div>
                        <span class="text-caption grey--text">Fecha de Termino</span>
                        <div class="font-weight-medium">
                          {{ formatoFechaHumano(getAdjudicacion.fechaTermino) }}
                        </div>
                      </div>
                    </v-timeline-item>
                  </v-timeline>
                </v-col>
                <v-col cols="12" md="4" class="d-flex align-center justify-center">
                  <div class="text-center">
                    <v-avatar size="80" color="primary lighten-4">
                      <span class="text-h5 primary--text font-weight-bold">
                        {{ getAdjudicacion.plazo || 0 }}
                      </span>
                    </v-avatar>
                    <div class="text-caption grey--text mt-2">dias de plazo</div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="rounded-lg mb-4">
            <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
              <v-icon left small color="white">mdi-office-building</v-icon>
              Obras Asociadas
              <v-chip x-small color="white" text-color="grey darken-3" class="ml-2">
                {{ getObras.length }}
              </v-chip>
            </v-card-title>
            <v-card-text class="pa-0">
              <template v-if="getObras.length > 0">
                <v-data-table
                  :headers="headers"
                  :items="getObras"
                  disable-pagination
                  disable-filtering
                  hide-default-footer
                  class="elevation-0">
                  <template v-slot:[`item.obra.clave`]="{ item }">
                    <span class="font-weight-medium primary--text">
                      {{ item.obra ? item.obra.clave : 'Sin clave' }}
                    </span>
                  </template>
                  <template v-slot:[`item.obra.tipo`]="{ item }">
                    <template v-if="item.obra && item.obra.tipo">
                      <v-chip small :color="item.obra.tipo.color">
                        {{ item.obra.tipo.descripcion }}
                      </v-chip>
                    </template>
                    <template v-else>
                      <span>Sin tipo</span>
                    </template>
                  </template>
                  <template v-slot:[`item.obra.subtipo`]="{ item }">
                    <template v-if="item.obra && item.obra.subtipo">
                      <v-chip small outlined :color="item.obra.subtipo.color">
                        {{ item.obra.subtipo.descripcion }}
                      </v-chip>
                    </template>
                    <template v-else>
                      <span>Sin subtipo</span>
                    </template>
                  </template>
                  <template v-slot:[`item.obra.meta`]="{ item }">
                    <span class="text-body-2">
                      {{ item.obra ? item.obra.meta : 'Sin descripcion' }}
                    </span>
                  </template>
                  <template v-slot:[`item.importe`]="{ item }">
                    {{ item.importe | currency }}
                  </template>
                  <template v-slot:[`item.total`]="{ item }">
                    {{ item.total | currency }}
                  </template>
                </v-data-table>
              </template>
              <template v-else>
                <div class="text-center py-10">
                  <v-icon size="60" color="grey lighten-2">
                    mdi-office-building-outline
                  </v-icon>
                  <p class="text-body-1 grey--text mt-4 mb-0">
                    Esta adjudicacion no tiene obras registradas
                  </p>
                </div>
              </template>
            </v-card-text>
          </v-card>

          <v-card class="rounded-lg">
            <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
              <v-icon left small color="white">mdi-history</v-icon>
              Informacion del Registro
            </v-card-title>
            <v-card-text class="pt-4">
              <v-row>
                <v-col cols="12" md="6">
                  <div class="text-caption grey--text">Fecha de Creacion</div>
                  <div class="font-weight-medium">
                    {{ formatoFechaHora(getAdjudicacion.createdAt) }}
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="text-caption grey--text">Ultima Actualizacion</div>
                  <div class="font-weight-medium">
                    {{ formatoFechaHora(getAdjudicacion.updatedAt) }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
export default {
  name: 'DefaultAdjudicacion',
  props: {
    adjudicacionDirecta: {
      type: Object,
      default: () => ({}),
    },
    cargandoAdjudicacion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Clave',
          class: 'grey--text text--darken-3 font-weight-bold',
          align: 'start',
          value: 'obra.clave',
          width: '120',
          sortable: false,
        },
        {
          text: 'Tipo',
          class: 'grey--text text--darken-3 font-weight-bold',
          value: 'obra.tipo',
          width: '140',
          sortable: false,
        },
        {
          text: 'Subtipo',
          class: 'grey--text text--darken-3 font-weight-bold',
          value: 'obra.subtipo',
          width: '140',
          sortable: false,
        },
        {
          text: 'Meta',
          class: 'grey--text text--darken-3 font-weight-bold',
          value: 'obra.meta',
          sortable: false,
        },
        {
          text: 'Importe',
          class: 'grey--text text--darken-3 font-weight-bold',
          value: 'importe',
          width: '120',
          sortable: false,
        },
        {
          text: 'Total',
          class: 'grey--text text--darken-3 font-weight-bold',
          value: 'total',
          width: '120',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    getAdjudicacion() {
      if (!this.adjudicacionDirecta) return {};
      return this.adjudicacionDirecta;
    },
    getContratista() {
      return this.getAdjudicacion.contratista || {};
    },
    getObras() {
      return this.getAdjudicacion.obras || [];
    },
    getUbicacionContratista() {
      const ubicacion = [
        this.getContratista.calle,
        this.getContratista.numero,
        this.getContratista.colonia,
        this.getContratista.municipio,
        this.getContratista.entidad,
      ].filter(Boolean);
      if (ubicacion.length <= 0) return 'Sin direccion';
      return ubicacion.join(', ');
    },
  },
  methods: {
    formatoFechaHumano(fecha) {
      if (!fecha) return 'Sin fecha';
      return new Date(`${fecha}T00:00:00`).toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
    formatoFechaHora(fecha) {
      if (!fecha) return 'Sin fecha';
      return new Date(fecha).toLocaleString('es-MX', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
  },
};
</script>

<style lang="scss">
</style>
